// Core React Imports
import React from "react";

// Local Imports
import { usePageWelcome } from "./usePageWelcome";

function PageWelcome() {
  usePageWelcome();

  return <div />;
}

export default PageWelcome;
